import DOMPurify from "dompurify";

export const formatHtmlContent = (content?: string): string => {
    try {
        // Check if content exists and is not just whitespace
        if (!content || typeof content !== 'string') {
            return '';
        }

        const trimmedContent = content.trim();
        if (!trimmedContent) {
            return '';
        }

        // Replace newlines with <br> tags
        const formattedContent = content.replace(/\n/g, '<br>');

        // Sanitize the content to prevent XSS attacks
        const sanitizedContent = DOMPurify.sanitize(formattedContent);

        // Additional validation that something meaningful remains after sanitization
        if (!sanitizedContent || !sanitizedContent.trim()) {
            console.warn('Content was empty after sanitization');
            return '';
        }

        return sanitizedContent;
    } catch (error) {
        console.error('Error formatting HTML content:', error);
        return ''; // Return empty string in case of any errors
    }
}
